import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

const PaymentConfirmDialog = ({ open, onClose, onConfirm, saving }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle variant='h4'>Επιβεβαίωση Πληρωμής</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Είστε βέβαιοι ότι θέλετε να δημιουργήσετε τη νέα πληρωμή;
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Άκυρο</Button>
        <Button disabled={saving} variant="contained" color="primary" onClick={onConfirm}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? "Ενημέρωση..." : "Επιβεβαίωση"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentConfirmDialog;
